import { FunctionComponent, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface MenuItemContentProps {
  className?: string;
  children: ReactNode;
}

/**
 *
 */
const MenuItemContentRoot: FunctionComponent<MenuItemContentProps> = ({
  className,
  children,
}) => {
  const css = cn(className, "px-4 py-2 text-sm block");
  return <div className={css}>{children}</div>;
};

export const MenuItemContent = Object.assign(MenuItemContentRoot, {});
